/* unplugin-vue-components disabled */import script from "./message-call-c2c.vue?vue&type=script&setup=true&lang=ts"
export * from "./message-call-c2c.vue?vue&type=script&setup=true&lang=ts"

import "./message-call-c2c.vue?vue&type=style&index=0&id=569fa905&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-569fa905"]])

export default __exports__